import React from 'react';
import PropTypes from 'prop-types';

import ProfilePolygon from './ProfilePolygon';
import CommunityProfilePolygon from './CommunityProfilePolygon';

import Custom from './Custom';

export function ProfileLayerComponent({ profile, setViewerPolygon, ...props }) {
  const { defaultOutline } = profile;
  if (defaultOutline === 'countiesActive' || defaultOutline === 'counties') {
    return (<ProfilePolygon profile={profile} setViewerPolygon={setViewerPolygon} {...props} />);
  }
  if (defaultOutline === 'communities') {
    return (<CommunityProfilePolygon
      profile={profile} setViewerPolygon={setViewerPolygon} {...props}
    />);
  }
  if (defaultOutline === 'shapefile') {
    return (<Custom shapefile={profile} setViewerPolygon={setViewerPolygon} {...props} />);
  }
  return null;
}

ProfileLayerComponent.propTypes = {
  profile: PropTypes.object,
  setViewerPolygon: PropTypes.func,
};

export default ProfileLayerComponent;



// WEBPACK FOOTER //
// ./src/components/Map/Layers/Profile.js